const Prod=() => {
    return(
        <div>
        <h2>생산 관리</h2>
        </div>
    )
}

export default Prod;